var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100"},[(_vm.ready)?_c('WebDataRocks',{key:_vm.key,attrs:{"report":_vm.pivotConfig,"global":_vm.pivotGlobal,"toolbar":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }